import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import NotificationBanner from 'design-system/NotificationBanner';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useSmartRulesNavigation } from 'hooks/useSmartRulesNavigation';
import { selectActiveSmartRulesByAccountId } from 'features/smart-rules/selectors';
import Section from 'design-system/Section';
import { CardView, SettingsItemNavigate, TextButtonLink } from 'design-system';
import { IconSmartRule } from 'design-system/icons';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectUserId } from 'reducers/selectors';
const SmartRuleSection = ({ account }) => {
    const { onPressSmartRules } = useSmartRulesNavigation();
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const userId = useAppSelector(selectUserId);
    const didCloseSmartRulesCard = useAppSelector((store) => store.deviceSettings.didCloseSmartRulesCard);
    const smartRules = useAppSelector((store) => selectActiveSmartRulesByAccountId(store, account.id));
    const onCancel = useCallback(() => {
        dispatch(setDeviceSettingsKey('didCloseSmartRulesCard', true));
    }, []);
    if (smartRules.length) {
        return (<Section title="Smart rules" button={<TextButtonLink text="Manage" onPress={() => onPressSmartRules(false)}/>} style={styles.section}>
        <CardView noMarginTop noMarginBottom>
          {smartRules.map(({ id, ruleName }) => (<SettingsItemNavigate key={id} title={ruleName} icon={<IconSmartRule />} onPress={() => navigation.navigateDeprecated('SmartRuleDetails', { id })}/>))}
        </CardView>
      </Section>);
    }
    const isCurrentUsersAccount = account.userId === userId;
    if (didCloseSmartRulesCard || !isCurrentUsersAccount)
        return null;
    return (<NotificationBanner noMarginTop noMarginBottom icon={<IconSmartRule />} title="Set a Smart Rule" lightButton cancelButtonTitle="Dismiss" positiveButtonTitle="Create" onPositiveBtnPress={() => onPressSmartRules(true)} onCancel={onCancel} description="Emma can automatically update the account balance for transfers between linked and offline accounts"/>);
};
const styles = StyleSheet.create({
    section: {
        marginBottom: 0,
    },
});
export default SmartRuleSection;
